const contactActions = {
    DEL_CONTACT: 'DEL_CONTACT',
    ADD_CONTACT: 'ADD_CONTACT',
    START: 'START',
    COMPLETE: 'COMPLETE',
};

export default contactActions;
